<template>
  <div>
    <el-dialog
      v-model="dialogVisible"
      width="80%"
      destroy-on-close
      append-to-body
      :show-close="false"
      :before-close="handleClose"
    >
      {{ promotion }}

      <template #footer></template>
      <template #header="{ close, titleId, titleClass }">
        <div class="my-header">
          <h4 :id="titleId" :class="titleClass">
            <a :href="`/promotions/${ promotion.id }`" class="w-100">
              {{ dt(promotion.title_translations) }}
            </a>
          </h4>
          <el-link :href="`/promotions/${ promotion.id }`" :underline="false" class="ml-2">
            <i class="czi-arrow-right font-size-lg" style="margin-right: 0px !important;"></i>
          </el-link>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { ElMessageBox } from 'element-plus'
import { dataTranslations as dt, priceRange } from "../../utils"
import { useVModel } from '@vueuse/core'

const props = defineProps({
  modelValue: Boolean,
  promotion: Object
})
const emit = defineEmits(['update:modelValue'])
const dialogVisible = useVModel(props, 'modelValue', emit)

const handleClose = () => {
  dialogVisible.value = false
}

</script>

<style scoped>
.my-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
